import React from 'react';
import PropTypes from 'prop-types';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrText from 'client/components/SrText';

const SrUtilityProfitPartnerUserConfirmationModal = ({ name, email, onClose }) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/checkmark-circle-large-green.svg"
      headline="Invite Sent!"
      maxWidth={400}
      minWidth={400}
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      message={
        <>
          <SrText fontSize="16px" lineHeight="25px" weight="500" display="block">
            We just sent {name} an email invite to: {email}
          </SrText>
          <SrText fontSize="16px" lineHeight="25px" weight="500" display="block" paddingTop="12px">
            Please tell them to check their email now.
          </SrText>
        </>
      }
      srMultiButtons={[
        {
          buttonText: 'Ok, thanks',
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
          onButtonClick: onClose,
        },
      ]}
    />
  );
};

SrUtilityProfitPartnerUserConfirmationModal.displayName =
  'SrUtilityProfitPartnerUserConfirmationModal';

SrUtilityProfitPartnerUserConfirmationModal.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SrUtilityProfitPartnerUserConfirmationModal;
